















































import { Component, Vue, Mixins, Prop } from "vue-property-decorator";
import store from "@/store";
import { Getter, Action } from "vuex-class";

@Component
export default class distributeConfirmModal extends Vue {
  @Prop() show!: boolean;
  @Getter('payType') payType!: string;
  @Getter('payNumber') payNumber!: number;
  @Getter('courseType') courseType !: string;
  @Getter("section") section!: Object;
  @Getter('courseGroupList') courseGroupList!: any;

  handleOk() {
    this.$emit("ok");
  }
  handleCancel() {
    this.$emit("cancel");
  }
  
  @Action("changeDistributeParameter") changeDistributeParameter!: Function;
  @Getter("hasOpenSMSVerify") hasOpenSMSVerify!: boolean;

  closeModla() {
    this.changeDistributeParameter({ openDistributeRewardModal: false });
  }
  getNumberStr(seqNo: number) {
    const arr = ['一', '二', '三', '四', '五', '六'];
    return arr[seqNo - 1];
  }
}
